import React from "react";
import { Paper, Chip, ListSubheader, Popper, Tooltip, Typography, Zoom, useMediaQuery, TextField } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
import { useTheme, styled } from '@mui/material/styles';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
// import CircularProgress from '@mui/material/CircularProgress';
// import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { VariableSizeList } from 'react-window';
import * as gtag from "../../../lib/google/gtag";
import { searchTicker } from "../../utils/helpers";

const Label = styled('label')(({ theme }) => ({
  padding: '0 0 4px',
  fontSize: 12,
  lineHeight: 1.5,
  display: 'block',
  color: theme.palette.primary.dark,
}));

const LISTBOX_PADDING = 8; // px
/* eslint-disable react/display-name */
function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
  };

  if (dataSet.hasOwnProperty('group')) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle} sx={{ fontWeight: 600, color: 'text.color.white', py: 0, lineHeight: '40px', height: '40px !important', bgcolor: 'background.primary_light' }}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  return (
    dataSet[1]?.t &&
    <Tooltip title={dataSet[1]?.n1.length > 30 ? dataSet[1]?.n1 : ''} disableInteractive TransitionComponent={Zoom}>
      <Typography component="li" {...dataSet[0]} noWrap style={inlineStyle}
        sx={{
          fontSize: '.8rem', textTransform: 'uppercase', color: 'text.description',
          // '&:hover': {
          //   color: 'text.color.white',
          //   '.MuiChip-root.MuiChip-filled': { visibility: 'visible' }
          // },
          position: 'relative',
        }}
      >
        <Chip label={dataSet[1]?.t} size="small" sx={{ position: 'absolute', right: 0, fontSize: '.7rem', color: 'text.link', zIndex: 2, mx: 1, visibility: '' }} />
        <Typography variant="caption" sx={{ textOverflow: 'ellipsis', width: '85%', overflow: 'hidden' }}>
          {dataSet[1]?.n1}
        </Typography>
      </Typography>
    </Tooltip >
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
    itemData.push(...(item.children || []));
  });

  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });

  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (child.hasOwnProperty('group')) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);
  let noofGroups = itemData.filter(val => {
    return val.group
  })?.length

  return (
    <div ref={ref}>
      {/* {noofGroups && itemData &&
        <Typography variant="caption" display="block" gutterBottom sx={{ textAlign: 'right', px: 2, pt: 1, color: 'text.description' }}>
          <Typography variant="caption" sx={{ color: '#000' }}>
            &nbsp;{itemData.length - noofGroups}&nbsp;
          </Typography>
          of 6003 results.
        </Typography>} */}
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};


const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
});

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}


// const ticker = ({ tab_data }) => {
const WatchlistTickerSearch = ({ setShowSearch, removebackdrop, handleTickerChange, tickers, selectedWatchlist }) => {
  const [value, setValue] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  // const router = useRouter()
  const loading = open && options.length === 0;
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSearch = (search_term) => {
    // router.push(`/stock/${search_term}`);
    gtag.event({
      action: "sec_search",
      search_term: search_term,
    });
  }

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      // await sleep(1e3); // For demo purposes.
      if (active) {
        // let stockSearch_jsonData = require('../../../public/assets/search/stock.json');
        // stockSearch_jsonData = stockSearch_jsonData.sort((a, b) => a?.t?.toUpperCase().localeCompare(b.t.toUpperCase()))
        let stockSearch_jsonData = await searchTicker({
          url: `/api/stock-search`,
          searchString: "",
        }) || [];
        setOptions([...stockSearch_jsonData]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  React.useEffect(() => {
    // setValue(tickers.map(ticker => ({ t: ticker.t })));
    setValue(tickers);
  }, [tickers]);

  return (
    <Paper
      // component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        margin: '0 auto',
        bgcolor: 'transparent',
        // zIndex: open ? (theme) => theme.zIndex.appBar : 0,
        width: { md: '45.5ch', sm: '45ch', xs: '100%' },
        // height: '1.4375em',
        // margin: '.5em 0 .481em 0',
        boxShadow: 0,
      }}
    >
      {/* <Label>Add tickers</Label> */}
      {/* {loading ?
          <CircularProgress color="inherit" size={20} sx={{ m: 1.5, color: "#fff" }} />
          :
          <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
            <SearchIcon
              sx={{ color: '#fff' }}
              onClick={e => e.preventDefault()}
            />
          </IconButton>} */}
      {/* <IconButton type="submit" sx={{ p: '10px', position: 'absolute' }} aria-label="search" onClick={e => e.preventDefault()}>
          <SearchIcon sx={{ color: 'primary.main', fontSize: '1.2rem' }} />
        </IconButton> */}
      <Autocomplete
        // autoComplete="off"
        limitTags={7}
        multiple
        autoHighlight
        id="search-ticker"
        disableListWrap
        PopperComponent={StyledPopper}
        ListboxComponent={ListboxComponent}
        sx={{
          color: 'text.primary',
          transition: 'all ease-in-out .2s',
          fontSize: '.87rem',
          '& .MuiPaper-root-MuiAutocomplete-paper': {
            boxShadow: 0
          },
          '& .MuiAutocomplete-input': {
            color: 'text.primary'
          },
          '&.MuiAutocomplete-root .MuiFilledInput-root .MuiAutocomplete-endAdornment svg': {
            color: 'text.primary',
          },
          '&.MuiAutocomplete-root .MuiFilledInput-root.MuiInputBase-sizeSmall .MuiFilledInput-input': {
            // padding: ' 2.5px 0 2.5px 32px',
            fontSize: '.875rem'
          },
          '& .MuiButtonBase-root.MuiChip-root': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '24px',
            margin: '2px 2px 0 0',
            lineHeight: '22px',
            backgroundColor: 'primary.dark',
            color: '#fff',
            border: '1px solid',
            borderColor: 'primary.dark',
            borderRadius: '4px',
            boxSizing: 'content-box',
            // padding: '0 4px 0 10px',
            outline: '0',
            overflow: 'hidden',

            '&:focus': {
              borderColor: '#40a9ff',
              backgroundColor: '#e6f7ff',
            },

            '& span': {
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            },

            '& svg': {
              fontSize: '15px',
              cursor: 'pointer',
              color: '#e8e8e8',
              padding: '4px',
            }
          }
        }}
        open={open}
        onOpen={() => { setOpen(true); }}
        // onClose={() => { setOpen(false); setShowSearch(false) }}
        onClose={() => { setOpen(false); }}
        onChange={(event, newValue) => { setValue(newValue); handleTickerChange(newValue); newValue && newValue.t ? handleSearch(newValue.t) : event.preventDefault() }}
        isOptionEqualToValue={(option, value) => option.t === value.t}
        // defaultValue={[]}
        value={value}
        options={options}
        loading={loading}
        filterOptions={(options, { inputValue }) => inputValue != "" && options.filter(item => item.n1.toLowerCase().startsWith(inputValue.toLowerCase()) || item.t.toLowerCase().startsWith(inputValue.toLowerCase())).sort((a, b) => a.t.length - b.t.length)}
        getOptionLabel={(option) => {
          // e.g value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          if (option.t) {
            // const _ticker = tickersDocCount && tickersDocCount.length > 0 ? tickersDocCount.find(d => d.key === option.t) : null
            // return _ticker?.doc_count ? `${option.t} (${_ticker?.doc_count})` : option.t;
            return option.t;
          }
          return '';
        }}
        selectOnFocus
        clearOnBlur
        clearOnEscape
        handleHomeEndKeys
        freeSolo
        // renderOption={(props, option) => <li {...props} style={{ fontSize: '.87rem', textTransform: 'uppercase' }}>{option.n1}</li>}
        renderOption={(props, option) => [props, option]}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            placeholder={value && value.length > 0 ? "" : "Eg., Apple, Tesla, MSFT"}
            // size="small"
            variant="filled"
            // hiddenLabel
            // clearOnBlur
            // clearOnEscape
            sx={{
              width: '97.5% !important',
              '& .MuiFilledInput-root': {
                pt: '4px !important',
                pb: '6px !important',
                pl: '6px !important',
                // p: '7px 12px 7px 12px !important',
              },
              '& .MuiFilledInput-root, .MuiFilledInput-root:hover, .MuiFilledInput-root:focus': {
                background: 'transparent',
              },
              '&  .MuiFilledInput-root, .MuiFilledInput-root:hover, .MuiFilledInput-root:before, .MuiFilledInput-root:after': {
                borderBottom: '0 !important',
              },
              '& .MuiInputBase-root.MuiFilledInput-root:before, .MuiInputBase.root-MuiFilledInput-root:hover:not(.Mui-disabled):before': {
                borderBottom: '0 !important',
              },
              '& .MuiInputBase-input.MuiFilledInput-input': {
                fontSize: '.875rem'
              },
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'action.hover',
              borderRadius: '4px',
            }}
          />
        )}
        renderGroup={(params) => params}
      />

    </Paper>
  );
}
export default (WatchlistTickerSearch);
